import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import App from '../../../components/App/App';
import Download from '../../../components/Download/Download';
import { getVersionsData, VersionsData } from '@/src/services/getVersionsData';

const SignupPage = ({ versionsData }: { versionsData: VersionsData }) => {
  return (
    <App>
      <Download versionsData={versionsData} />
    </App>
  );
};

export const getServerSideProps = async ({ locale, res }) => {
  res.setHeader('Cache-Control', 'public, s-maxage=3600, stale-while-revalidate=7200');

  let versionsData = { current: null, beta: null, previous: [] };
  try {
    versionsData = await getVersionsData();
  } catch (e) {
    console.error('Failed to fetch versions data:', e);
  }

  return {
    props: {
      ...(await serverSideTranslations(locale, ['common'])),
      versionsData,
    },
  };
};

export default SignupPage;
